// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const CloudInventoryProviderSchema = z.enum(['aws','gcp','azure','cloudflare'] as const);

export type CloudInventoryProviderType = `${z.infer<typeof CloudInventoryProviderSchema>}`

export default CloudInventoryProviderSchema;
